import { useSelector } from 'react-redux';
import { selectRouteGuideId } from '../selectors/app';
import { getSelectCategory } from '../selectors/categories';
import { getSelectProfile } from '../selectors/profiles';

export default function useRouteGuideItem() {
  const guideId = useSelector(selectRouteGuideId);
  const categoryGuideItem = useSelector(getSelectCategory(guideId));
  const profileGuideItem = useSelector(getSelectProfile(guideId));

  return categoryGuideItem || profileGuideItem;
}
